/**
 * Normalize spacing around {tag} tokens.
 * - Ensure a space before {tag} if preceded by non-whitespace (except > for HTML)
 * - Ensure a space after {tag} if followed by non-whitespace (except < for HTML)
 * - No space between {tag} and comma (both languages)
 * - No space between {tag} and . ! ? ; : (English only; French keeps space per typography)
 */
export function normalizeTagSpacing(text, lang) {
  if (!text) return text;
  // Strip zero-width spaces inserted by tag picker, then space before/after tags
  let r = text.replace(/\u200B/g, "").replace(/([^\s>])\{(\w+)\}/g, "$1 {$2}");
  // Space after tag if followed by non-whitespace, non-< char (except punctuation)
  const noSpace = lang === "fr" ? /^[,]$/ : /^[.,!?;:]$/;
  r = r.replace(/\{(\w+)\}([^\s<])/g, (m, tag, ch) =>
    noSpace.test(ch) ? m : `{${tag}} ${ch}`,
  );
  return r;
}

/**
 * Apply normalizeTagSpacing to all string fields in a communications object.
 */
export function normalizeCommsTagSpacing(comms) {
  if (!comms) return comms;
  const result = { ...comms };
  for (const key of Object.keys(result)) {
    const val = result[key];
    if (!val || typeof val !== "object") continue;
    // Detect lang-keyed objects like { en: "...", fr: "..." }
    if (typeof val.en === "string" || typeof val.fr === "string") {
      result[key] = {
        ...val,
        ...(typeof val.en === "string"
          ? { en: normalizeTagSpacing(val.en, "en") }
          : {}),
        ...(typeof val.fr === "string"
          ? { fr: normalizeTagSpacing(val.fr, "fr") }
          : {}),
      };
    }
    // Detect nested objects like subject: { en, fr }, title: { en, fr }, body: { en, fr }
    if (typeof val === "object" && !Array.isArray(val)) {
      for (const subKey of Object.keys(val)) {
        const sub = val[subKey];
        if (
          sub &&
          typeof sub === "object" &&
          (typeof sub.en === "string" || typeof sub.fr === "string")
        ) {
          result[key] = {
            ...result[key],
            [subKey]: {
              ...sub,
              ...(typeof sub.en === "string"
                ? { en: normalizeTagSpacing(sub.en, "en") }
                : {}),
              ...(typeof sub.fr === "string"
                ? { fr: normalizeTagSpacing(sub.fr, "fr") }
                : {}),
            },
          };
        }
      }
    }
  }
  return result;
}
